import { helper as buildHelper } from '@ember/component/helper';

export function messageCenterGetThreadPrimaryRecipient(params/*, hash*/) {

  let thread = params[0];
  let currentUser = params[1];

  let threadUsers = thread.get('users');
  let primaryRecipient;

  // If the thread is new, it won't have any meta information, so we can just
  // inspect the thread's users

  if(thread.get('isNew')) {
    threadUsers.any(user => {
      if(user.get('id').toString() !== currentUser.get('id').toString()) {
        primaryRecipient = user;
        return true;
      }
    });

    return primaryRecipient;
  }

  // Otherwise (if the thread was loaded from the server, or was created + subsequently saved)
  // we'll need to inspect the watcher information

  let threadMetaUsers = thread.get('etc.relationships.users');
  let watchedBy = new Set(thread.get('watchedBy'));

  if(watchedBy.has(currentUser.get('id').toString())) {
    threadMetaUsers.any((threadMetaUser) => {
      if (threadMetaUser.role === 'seller') {
        threadUsers.any(user => {
          if(user.get('id').toString() === threadMetaUser.user_id.toString()) {
            primaryRecipient = user;
            return true;
          }
        });
        return true;
      }
    });
  } else {
    threadMetaUsers.any((threadMetaUser) => {
      if (parseInt(threadMetaUser.user_id) !== parseInt(currentUser.get('id')) && threadMetaUser.role !== 'watcher') {
        threadUsers.any(user => {
          if(user.get('id').toString() === threadMetaUser.user_id.toString()) {
            primaryRecipient = user;
            return true;
          }
        });
        return true;
      }
    });
  }

  return primaryRecipient;
}

export default buildHelper(messageCenterGetThreadPrimaryRecipient);
